import { render, staticRenderFns } from "./DomicilioElectoral.vue?vue&type=template&id=6f751c20"
import script from "./DomicilioElectoral.vue?vue&type=script&lang=js"
export * from "./DomicilioElectoral.vue?vue&type=script&lang=js"
import style0 from "./DomicilioElectoral.vue?vue&type=style&index=0&id=6f751c20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports